export function getAllowInvoiceFlagKey(value: AllowInvoiceFlagStatus): AllowInvoiceFlagStatusKey {
    const entry = Object.entries(AllowInvoiceFlagStatusEnum).find(([, v]) => v === value);

    if (!entry) {
        throw new Error("Invalid AllowInvoiceFlagStatus value");
    }

    return entry[0] as AllowInvoiceFlagStatusKey;
}

export const AllowInvoiceFlagStatusEnum = {
    ALLOWED: true,
    DISALLOWED: false,
    NOT_SET: null,
} as const;

export type AllowInvoiceFlagStatusKey = keyof typeof AllowInvoiceFlagStatusEnum;

export type AllowInvoiceFlagStatus = (typeof AllowInvoiceFlagStatusEnum)[AllowInvoiceFlagStatusKey];
